export default __webpack_public_path__ + "static/media/facebook.28ac1b35.svg";